var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChildCareSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Childcare icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3333 22.6667C18.7515 22.6667 22.3333 19.0849 22.3333 14.6667C22.3333 10.2484 18.7515 6.66666 14.3333 6.66666C9.91497 6.66666 6.33325 10.2484 6.33325 14.6667C6.33325 19.0849 9.91497 22.6667 14.3333 22.6667Z",
    fill: "#FC92A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.2 13.6667C20.1066 13.6667 20.0176 13.684 19.9274 13.6967C18.9884 9.65818 15.6513 6.66666 11.6667 6.66666C7.68199 6.66666 4.34507 9.65804 3.40593 13.6967C3.3157 13.684 3.22677 13.6667 3.13331 13.6667C1.95507 13.6667 1 14.7113 1 16C1 17.2887 1.95507 18.3333 3.13331 18.3333C3.22677 18.3333 3.3157 18.316 3.40593 18.3033C4.34494 22.3418 7.68199 25.3333 11.6667 25.3333C15.6513 25.3333 18.9883 22.3418 19.9274 18.3033C20.0176 18.316 20.1066 18.3333 20.2 18.3333C21.3783 18.3333 22.3333 17.2887 22.3333 16C22.3333 14.7113 21.3783 13.6667 20.2 13.6667Z",
    stroke: "#213332",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.66667 6.66668C9.66667 6.66668 8.16667 5.60008 9.66667 4.00001C11.1667 2.40006 9.66667 1.33334 9.66667 1.33334",
    stroke: "#213332",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.33334C11.6667 2.93342 11.6667 1.33334 11.6667 1.33334V5.33334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.33334C11.6667 2.93342 11.6667 1.33334 11.6667 1.33334",
    stroke: "#213332",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.6667 21.3333C13.8759 21.3333 15.6667 20.1394 15.6667 18.6667C15.6667 17.1939 13.8759 16 11.6667 16C9.45761 16 7.66675 17.1939 7.66675 18.6667C7.66675 20.1394 9.45761 21.3333 11.6667 21.3333Z",
    fill: "#FC92A5",
    stroke: "#213332",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.66675 14.6667C7.66675 13.9303 7.96521 13.3333 8.33341 13.3333C8.70162 13.3333 9.00008 13.9303 9.00008 14.6667",
    stroke: "#213332",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.3333 14.6667C14.3333 13.9303 14.6317 13.3333 14.9999 13.3333C15.3681 13.3333 15.6666 13.9303 15.6666 14.6667",
    stroke: "#213332",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildCareSupport);
export default __webpack_public_path__ + "static/media/child_care_support.642404d231934ccfe48ed630b1db9487.svg";
export { ForwardRef as ReactComponent };